goog.provide("shadow.js.shim.module$react_hook_form");
goog.provide("module$shadow_js_shim_module$react_hook_form");
shadow.js.shim.module$react_hook_form = shadow.js.nativeProvides["react-hook-form"] = shadow$bridge("react-hook-form");
module$shadow_js_shim_module$react_hook_form.default = shadow.js.shim.module$react_hook_form;
